import styled from 'styled-components';

export const StyledExperience = styled.div`
`;
